<template>
  <v-dialog :value="visible" @input="onDialogInput" persistent max-width="850">
    <v-card elevation="24" class="border-radius policeLato">
      <v-card-text style="background:#FAFAFA">
        <div class="wizard-tab-content">
          <div role="tabpanel" id="EditVehicleInfo" class="wizard-tab-container">
            <div>
              <div class="loan-group loan-group-0">
                <div class="fields">
                  <div class="field-title font-weight-bold">Modifier le véhicule&nbsp;:</div>

                  <!-- IDENTIFICATION -->
                  <div class="row mt-3">
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_marque" class="field-label">Marque <span class="required-star">*</span></label>
                        <input type="text" v-model="form.marque" id="edit_marque" class="field-input" placeholder="Ex: Toyota">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_model" class="field-label">Modèle <span class="required-star">*</span></label>
                        <input type="text" v-model="form.model" id="edit_model" class="field-input" placeholder="Ex: Corolla">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_categorie" class="field-label">Catégorie <span class="required-star">*</span></label>
                        <select v-model="form.categorie" id="edit_categorie" class="field-select">
                          <option v-for="c in categorieOptions" :key="c" :value="c">{{ categorieLabel(c) }}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_immatriculation" class="field-label">Immatriculation <span class="required-star">*</span></label>
                        <input type="text" maxlength="10" v-model="form.immatriculation" id="edit_immatriculation" @input="validateImmatriculation" class="field-input" placeholder="XX-XXX-XX">
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_numeroChassis" class="field-label">Numéro de châssis (VIN)</label>
                        <input type="text" maxlength="17" v-model="form.numeroChassis" id="edit_numeroChassis" class="field-input">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_nom" class="field-label">Nom du propriétaire</label>
                        <input type="text" v-model="form.nom_proprietaire" id="edit_nom" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_prenom" class="field-label">Prénom du propriétaire</label>
                        <input type="text" v-model="form.prenom_proprietaire" id="edit_prenom" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_dateCircule" class="field-label">Date de mise en circulation</label>
                        <input type="date" v-model="form.dateCircule" id="edit_dateCircule" class="field-input">
                      </div>
                    </div>
                  </div>

                  <!-- CARACTERISTIQUES -->
                  <div class="row mt-3">
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_carburation" class="field-label">Carburant</label>
                        <select v-model="form.carburation" id="edit_carburation" class="field-select">
                          <option value="">—</option>
                          <option value="Essence">Essence</option>
                          <option value="Diésel">Diésel</option>
                          <option value="Hybride">Hybride</option>
                          <option value="Electrique">Electrique</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_force" class="field-label">Puissance fiscale (CV)</label>
                        <input type="number" min="1" v-model="form.force" id="edit_force" class="field-input" placeholder="Ex: 8">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_nbplace" class="field-label">Nombre de places</label>
                        <input type="number" min="1" v-model="form.nbplace" id="edit_nbplace" class="field-input" placeholder="Ex: 5">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-sm-4" v-if="isTwoWheels">
                      <div class="field-group field-default">
                        <label for="edit_volumetrie" class="field-label">Volumétrie 2 roues</label>
                        <select v-model="form.volumetrie2_roues" id="edit_volumetrie" class="field-select">
                          <option value="">—</option>
                          <option value="50">50 cm³</option>
                          <option value="125">125 cm³</option>
                          <option value="126">Entre 125 et 400 cm³</option>
                          <option value="401">Plus de 400 cm³</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-4" v-if="isTwoWheels">
                      <div class="field-group field-default">
                        <label for="edit_cylindre" class="field-label">Cylindrée (cm³)</label>
                        <input type="number" min="0" v-model="form.cylindre" id="edit_cylindre" class="field-input" placeholder="Ex: 125">
                      </div>
                    </div>
                    <div class="col-sm-4" v-if="isUtilitaire">
                      <div class="field-group field-default">
                        <label for="edit_optionUtilitaire" class="field-label">Option utilitaire</label>
                        <select v-model="form.optionUtilitaire" id="edit_optionUtilitaire" class="field-select">
                          <option value="">—</option>
                          <option value="Pour Compte">Pour Compte</option>
                          <option value="Pour Tiers">Pour Tiers</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-4" v-if="isUtilitaire">
                      <div class="field-group field-default">
                        <label for="edit_tonnage" class="field-label">Tonnage / Carrosserie</label>
                        <input type="text" v-model="form.tonnage" id="edit_tonnage" class="field-input">
                      </div>
                    </div>
                  </div>

                  <!-- VALEURS -->
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_valeur" class="field-label">Valeur neuve (FCFA)</label>
                        <input type="number" min="0" v-model="form.valeur" id="edit_valeur" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_valeur_venale" class="field-label">Valeur actuelle (FCFA) <span class="required-star">*</span></label>
                        <input type="number" min="0" v-model="form.valeur_venale" id="edit_valeur_venale" class="field-input">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wizard-card-footer clearfix">
          <div class="wizard-footer-left">
            <button @click="cancel" type="button" class="wizard-btn" :disabled="saving">
              <span class="fas fa-arrow-left"></span>
              Retour
            </button>
          </div>
          <div class="wizard-footer-right">
            <button @click="save" type="button" class="wizard-btn" :disabled="saving">
              <span v-if="saving" class="fas fa-spinner fa-spin"></span>
              {{ saving ? 'Enregistrement...' : 'Enregistrer' }}
            </button>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VehicleService from '../../services/portefeuille/VehicleService'

const EMPTY_FORM = () => ({
  id: '',
  marque: '',
  model: '',
  categorie: '',
  numeroChassis: '',
  nom_proprietaire: '',
  prenom_proprietaire: '',
  immatriculation: '',
  volumetrie2_roues: '',
  cylindre: '',
  force: '',
  nbplace: '',
  carburation: '',
  valeur: '',
  valeur_venale: '',
  optionUtilitaire: '',
  tonnage: '',
  dateCircule: '',
  carosserie: '',
  flotte_mono: ''
})

export default {
  name: 'EditVehicleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    vehicle: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: EMPTY_FORM(),
      saving: false
    }
  },
  computed: {
    isTwoWheels() {
      return this.form.categorie === '2_roues' || this.form.categorie === 'categorie 5'
    },
    isUtilitaire() {
      return this.form.categorie === 'utilitaire'
    },
    categorieOptions() {
      const base = ['tourisme', '2_roues', 'utilitaire']
      if (this.form.categorie && base.indexOf(this.form.categorie) === -1) {
        return [this.form.categorie, ...base]
      }
      return base
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.populateForm()
      }
    },
    vehicle() {
      if (this.visible) {
        this.populateForm()
      }
    }
  },
  methods: {
    onDialogInput(value) {
      if (!value) {
        this.$emit('close')
      }
    },
    formatDateForInput(date) {
      if (!date) return ''
      const d = new Date(date)
      if (isNaN(d.getTime())) return ''
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${d.getFullYear()}-${month}-${day}`
    },
    populateForm() {
      const v = this.vehicle || {}
      this.form = {
        ...EMPTY_FORM(),
        id: v._id || v.id || v.car_id || v.vehicule_id || '',
        marque: v.marque || '',
        model: v.model || '',
        categorie: v.categorie || v._categorie || '',
        numeroChassis: v.numeroChassis || v.numero_chassis || '',
        nom_proprietaire: v.nom_proprietaire || v.nom || '',
        prenom_proprietaire: v.prenom_proprietaire || v.prenom || '',
        immatriculation: v.immatriculation || '',
        volumetrie2_roues: v.volumetrie2_roues || '',
        cylindre: v.cylindre || '',
        force: v.force || '',
        nbplace: v.nbplace || '',
        carburation: v.carburation || '',
        valeur: v.valeur || '',
        valeur_venale: v.valeur_venale || '',
        optionUtilitaire: v.optionUtilitaire || '',
        tonnage: v.tonnage || '',
        dateCircule: this.formatDateForInput(v.dateCircule),
        carosserie: v.carosserie || '',
        flotte_mono: v.flotte_mono || ''
      }
    },
    toNumber(value) {
      if (value === '' || value === null || value === undefined) return ''
      const n = Number(value)
      return isNaN(n) ? value : n
    },
    buildPayload() {
      const f = this.form
      return {
        id: f.id,
        marque: f.marque,
        model: f.model,
        categorie: f.categorie,
        numeroChassis: f.numeroChassis,
        nom_proprietaire: f.nom_proprietaire,
        prenom_proprietaire: f.prenom_proprietaire,
        immatriculation: f.immatriculation,
        volumetrie2_roues: f.volumetrie2_roues,
        cylindre: this.toNumber(f.cylindre),
        force: this.toNumber(f.force),
        nbplace: f.nbplace,
        carburation: f.carburation,
        valeur: this.toNumber(f.valeur),
        valeur_venale: this.toNumber(f.valeur_venale),
        optionUtilitaire: f.optionUtilitaire,
        tonnage: f.tonnage,
        dateCircule: f.dateCircule,
        carosserie: f.carosserie,
        flotte_mono: f.flotte_mono
      }
    },
    validateImmatriculation() {
      // Formats acceptés: XX-XXXX-XX ou XX-XXX-XX
      const regex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{3,4}-[A-Za-z0-9]{2}$/
      if (!regex.test(this.form.immatriculation)) {
        this.form.immatriculation = this.form.immatriculation.replace(/[^A-Za-z0-9-]/g, '')
      }
    },
    showToast(message, type) {
      this.$toasted.clear()
      this.$toasted.show(message, {
        theme: 'toasted-primary',
        position: 'top-center',
        type: type || 'error',
        duration: 3000,
        singleton: true
      })
    },
    cancel() {
      this.$emit('close')
    },
    async save() {
      if (!this.form.id) {
        this.showToast("L'identifiant du véhicule est requis")
        return
      }
      if (!this.form.marque) {
        this.showToast('La marque du véhicule est obligatoire')
        return
      }
      if (!this.form.model) {
        this.showToast('Le modèle du véhicule est obligatoire')
        return
      }
      if (!this.form.immatriculation) {
        this.showToast("L'immatriculation du véhicule est obligatoire")
        return
      }
      const immatRegex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{3,4}-[A-Za-z0-9]{2}$/
      if (!immatRegex.test(this.form.immatriculation)) {
        this.showToast("Format d'immatriculation non respecté (XX-XXXX-XX ou XX-XXX-XX)")
        return
      }

      this.saving = true
      try {
        const response = await VehicleService.updateVehicle(this.form.id, this.buildPayload())
        const car = (response && response.data && (response.data.car || response.data)) || null
        this.showToast('Le véhicule a été mis à jour', 'success')
        this.$emit('saved', car)
        this.$emit('close')
      } catch (error) {
        const msg =
          (error.response && error.response.data && error.response.data.msg) ||
          'Erreur lors de la modification du véhicule'
        this.showToast(msg)
      } finally {
        this.saving = false
      }
    },
    categorieLabel(cat) {
      const labels = {
        tourisme: 'Véhicule particulier',
        '2_roues': 'Véhicule 2 roues',
        utilitaire: 'Véhicule utilitaire'
      }
      return labels[cat] || cat
    }
  }
}
</script>

<style scoped lang="less">
.field-title {
  font-size: 1.2rem;
  color: #1a1a1a;
}

.required-star {
  color: #e74c3c;
}

.field-group {
  margin-bottom: 0.5rem;
}

.field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.35rem;
}

.field-input,
.field-select {
  width: 100%;
  height: 42px;
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
  color: #333;
  background-color: #fff;
  border: 1px solid #d9dee3;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  font-family: 'Lato', sans-serif;
}

.field-input:focus,
.field-select:focus {
  border-color: #ffa409;
}

.wizard-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.wizard-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffa409;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.wizard-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.wizard-footer-left .wizard-btn {
  background: transparent;
  color: #666;
  border: 1px solid #ccc;
}
</style>
